/*
 * 内容容器
 * */

'use strict';
var React = require('react');
var compHelper = require('./Components/compHelper');

var Comments = React.createClass({
  propTypes: {
    position: React.PropTypes.shape({
      x: React.PropTypes.number,
      y: React.PropTypes.number
    }).isRequired,
    components: React.PropTypes.array
  },
  render: function () {
    return (
      <div className="comments" key={'components' + this.props.controlID} style={{
        left: this.props.position.x,
        top: this.props.position.y,
        display: this.props.show ? 'block' : 'none'
      }}>
        <div
          id="comments-scroller"
          style={{
            position: 'relative',
            top: 0
          }}>
          {this.props.components.map(compHelper.makeComp)}
        </div>
      </div>
    );
  }
});

module.exports = Comments;


// WEBPACK FOOTER //
// ./src/views/Comments.jsx